import { useState } from "react";
import { Link } from "react-router-dom";

import { Button } from "@/components/ui/Button";
import { Textarea } from "@/components/ui/Field";
import {
  useSettings,
  useUpdateSettings,
} from "@/features/settings/useSettings";
import { Section } from "@/components/ui/Page";

/**
 * The terms every crew agreement carries (docs/principles.md 1.1-1.3).
 * Changing them affects agreements sent from now on; signed ones keep the
 * words they were signed with. The people themselves live under Team.
 */
export function TeamSettingsPage() {
  const settings = useSettings();
  const update = useUpdateSettings();
  const [terms, setTerms] = useState<string | null>(null);
  const value = terms ?? settings.data?.crew_terms ?? "";

  return (
    <div className="max-w-4xl">
      <Section
        title="Crew agreement terms"
        description="Added under every booking you send a photographer or videographer. Changes apply to agreements sent from now on; signed agreements keep the words they were signed with."
      >
        <p className="mb-3 text-[length:var(--text-sm)] text-taupe">
          The people, their rates, weddings, invoices and payments are under{" "}
          <Link to="/settings/team" className="underline underline-offset-4">
            Team
          </Link>
          .
        </p>
        <Textarea
          rows={18}
          value={value}
          onChange={(event) => setTerms(event.target.value)}
        />
        <div className="mt-3">
          <Button
            disabled={terms === null || terms === settings.data?.crew_terms}
            loading={update.isPending}
            onClick={() =>
              update.mutate(
                { crew_terms: value },
                { onSuccess: () => setTerms(null) },
              )
            }
          >
            Save terms
          </Button>
        </div>
      </Section>
    </div>
  );
}
